export default [
    {
      path: '/admin/quotations',
      name: 'quotation',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/quotation/index.vue')
    },
    {
      path: '/admin/quotations/create',
      name: 'quotation-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/quotation/create.vue')
    },
    {
      path: '/admin/quotations/:id/edit',
      name: 'quotation-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/wholesale/quotation/edit.vue')
    }
  ]
  